// export {flexi} from './skills/flexi.svg';


// export {layout} from './skills/layout.svg';
// import react from './skills/react.svg';
// export default react;


import githubs from './home/github.svg'
import courses from './projects/course.PNG';
import firebases from './projects/firebase.png';
import weathers from './projects/weather-application.PNG';
import baflixs from './projects/baflix.png'
import bowlings from './projects/bowling.PNG'
import portfolio2s from './projects/portfolio2.PNG'
import fullstacks from './projects/react-node-express2.PNG';
import coronas from './projects/react-corona.PNG';
import todoapps from './projects/to-do-app.PNG';
import reactArticles from './projects/react-articles.PNG';
import hotels from './projects/react-hotel.PNG';
import twitterss from './projects/twitters.PNG';
import weatherReacts from './projects/weather-application-react.PNG';
import ecommerss from './projects/ecommers2.PNG';
import generates from './projects/generate.PNG';
import robotos from './projects/Roboto.png';
import teniss from './projects/tenis.PNG';
import snakes from './projects/snake2.PNG';
import moviess from './projects/movies.png';
import memes from './projects/memegenerator.PNG';
import encripts from './projects/encrypt-decrypt.PNG';
import appPosts from './projects/appposts.png';
import fullStacks from './projects/fullstack2.png';
import appHotels from './projects/app-hotel.png';
import cmdStalowas from './projects/cmdstalowa.png';
import ingrifoImage from './projects/ingrifo.png';
import xtmImage from './projects/xtm.png';
import trinityImage from './projects/trinity.png';
import bankImage from './projects/bank.png';

export const github = githubs;
export const course = courses;
export const firebase = firebases ;
export const weather = weathers;
export const baflix = baflixs;
export const bowling = bowlings;
export const portfolio2 = portfolio2s;
export const fullstack = fullstacks;
export const corona = coronas ;
export const todoapp = todoapps;
export const reactArticle = reactArticles;
export const hotel = hotels;
export const twitters = twitterss ;
export const weatherReact = weatherReacts;
export const ecommers = ecommerss;
export const generate = generates;
export const roboto = robotos;
export const tenis = teniss;
export const snake = snakes;
export const movies = moviess;
export const meme = memes;
export const encript = encripts;
export const appPost = appPosts;
export const fullStack = fullStacks;
export const appHotel = appHotels;
export const cmdStalowa = cmdStalowas;
export const ingrifo = ingrifoImage;
export const xtm = xtmImage;
export const trinity = trinityImage
export const bank = bankImage;

